import { useTheme } from '@mui/styles';

import {
  CELL_FONT_SIZE,
  CELL_SPACING,
  CELL_WIDTH,
  CUSTOM_PADDING,
  DAY_GRAY,
  TODAY_COLOR,
  outOfRangeBackground,
} from '~/components/EmployeeCalendar/data';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    dayCellWrapper: {
      width: `${CELL_WIDTH}px`,
      padding: `${CELL_SPACING}px`,
      boxSizing: 'content-box',
      display: 'flex',
      alignItems: 'center',
      minHeight: '22px',
    },
    todayCellWrapper: {
      backgroundColor: TODAY_COLOR,
      marginLeft: `${CELL_SPACING * -1}px`,
      marginRight: `${CELL_SPACING * -1}px`,
      paddingLeft: `${CELL_SPACING * 2}px`,
      paddingRight: `${CELL_SPACING * 2}px`,
    },
    default: {
      width: `${CELL_WIDTH}px`,
      height: '100%',
      textAlign: 'center',
      display: 'inline-block',
      backgroundColor: DAY_GRAY,
      flexShrink: 0,
      padding: `${CUSTOM_PADDING}px`,
      fontSize: CELL_FONT_SIZE,
    },
    event: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
    },
    endOfRangeWrapper: {
      opacity: 0.3,
    },
    endOfRange: {
      backgroundImage: outOfRangeBackground,
    },
    hideOutOfRange: {
      display: 'none',
    },
  };
};
